export const WEIGHT_FACTOR = 7;
